import Vue from 'vue';

class Store<S> {
  private instance: Vue

  constructor() {
    this.instance = new Vue({
      data: {
        isLoading: false,
      },
    });
  }

  get state(): S {
    return (this.instance.$data as any) as S;
  }

  get isLoading(): boolean {
    return this.instance.$data.isLoading;
  }

  setIsLoading = (loading: boolean) => {
    this.instance.$data.isLoading = loading;
  }
}

export interface State {
  isLoading: boolean;
}

class LoadingStore extends Store<State> {}
export default LoadingStore;
